(function($) {
  $(function() {
    var hide = false;

    setTimeout(function() {
      $('.contact-widget').removeClass('contact-widget--hidden');
    }, 3000);

    $('.contact-widget__hide').click(function() {
      hide = true;
      $('.contact-widget').addClass('contact-widget--hidden');
    });
    
    $('.contact-widget__toggle, .contact-widget__close').click(function() {
      if(hide) {
        return;
      }

      $('.contact-widget').toggleClass('contact-widget--expanded');
      setTimeout(function() {
        $('.contact-widget').toggleClass('contact-widget--reverse-delay');
      });
    });
  });
})(jQuery);